import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import FormAction from "./formAction";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ToeflScore(props) {
  const [state, setState] = useState({
    formData: {
      percent_completed: 60,
      completed_submitted_toefl: null,
      toefl_resume: "demo field",
      date_of_toefl: "",
      month_of_toefl: "",
      year_of_toefl: "",
    },
    completed_submitted_toeflValid: "",
    date_of_toeflValid: true,
    month_of_toeflValid: true,
    year_of_toeflValid: true,
    isFormDataValid: false,
  });

  const [startDate, setStartDate] = useState(new Date());
  const { savedSteps, bayanProgress, selectedProgramLabel } = useSelector(
    (state) => ({
      savedSteps: state.applicationReducer.savedSteps,
      bayanProgress: state.applicationReducer.bayanProgress,
      selectedProgramId: state.applicationReducer.selectedProgramId,
      selectedProgramLabel: state.applicationReducer.selectedProgramLabel,
    }),
    shallowEqual
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!!savedSteps.toeflScore) {
      populateForm();
    } else {
      iterateDate(startDate);
    }
  }, []);

  useEffect(() => {
    validateForm();
  }, [state]);

  function populateForm() {
    const toeflScoreData = savedSteps.toeflScore;
    if (!!savedSteps.toeflScore && Object.keys(toeflScoreData).length > 0) {
      updateForm(
        "completed_submitted_toefl",
        toeflScoreData.completed_submitted_toefl
      );
      const month =
        (toeflScoreData.month_of_toefl && toeflScoreData.month_of_toefl < 1) ||
        toeflScoreData.month_of_toefl > 12
          ? 1
          : toeflScoreData.month_of_toefl;
      const date =
        (toeflScoreData.date_of_toefl && toeflScoreData.date_of_toefl < 1) ||
        toeflScoreData.date_of_toefl > 31
          ? 1
          : toeflScoreData.date_of_toefl;
      updateForm("date_of_toefl", date);
      updateForm("month_of_toefl", month);
      updateForm("year_of_toefl", toeflScoreData.year_of_toefl);
      if (
        !!toeflScoreData.date_of_toefl &&
        toeflScoreData.month_of_toefl &&
        toeflScoreData.year_of_toefl
      ) {
        setStartDate(
          new Date(
            formatDate(
              toeflScoreData.month_of_toefl,
              toeflScoreData.date_of_toefl,
              toeflScoreData.year_of_toefl
            )
          )
        );
      }
    }
  }

  const formatDate = (mon, date, year) => {
    return mon + "/" + date + "/" + year;
  };

  const updateForm = (field, value) => {
    // debugger;
    let temp = state.formData;
    temp[field] = value;
    setState((prevState) => ({ ...prevState, formData: temp }));
    _validate(field);
  };
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch (field) {
      case "completed_submitted_toefl":
        regex = /^.{1,}/;
        valid = regex.test(value);
        break;
      case "date_of_toefl":
      case "month_of_toefl":
      case "year_of_toefl":
        valid = true;
        break;
    }
    setState((prevState) => ({ ...prevState, [field + "Valid"]: valid }));
  };

  const validateForm = () => {
    let formData = state;
    let form =
      !!formData.completed_submitted_toeflValid &&
      !!formData.date_of_toeflValid &&
      !!formData.month_of_toeflValid &&
      !!formData.year_of_toeflValid;
    if (state.isFormDataValid != form) {
      setState((prevState) => ({ ...prevState, isFormDataValid: form }));
    }
  };

  const iterateDate = (dateObj) => {
    if (dateObj) {
      const month = dateObj.getMonth() + 1; //months given = 0-11, add +1 for actual month
      const date = dateObj
        ? dateObj.getDate() > 31
          ? 31
          : dateObj.getDate()
        : null;
      const year = dateObj.getFullYear();
      updateForm("month_of_toefl", month);
      updateForm("date_of_toefl", date);
      updateForm("year_of_toefl", year);
      setStartDate(dateObj);
    } else {
      setStartDate(null);
    }
  };

  const setMinDate = () => {
    // const date = new Date();
    // return date;
    const date = new Date();
    return date.setFullYear(date.getFullYear() - 10);
  };

  const setMaxDate = () => {
    // const date = new Date();
    // return date.setFullYear(date.getFullYear()+10)
    const date = new Date();
    return date.setFullYear(date.getFullYear());
  };

  return (
    <>
      <div className="app-form-container residency toeflsrs">
        <div className="main-heading bayan-main-heading">
          {selectedProgramLabel}
        </div>
        <div className="sub-heading app-info">TOEFL Scores</div>
        <div className="form-content">
          <div className="input-group">
            <div className="field-label">
              If you are an international student and English is a second
              language, you must complete the TOEFL exam and have your scores
              submitted directly to CTS. If this applies to you, have you
              completed the TOEFL exam and submitted your official scores to
              Chicago Theological Seminary? (TOEFL code: 1120)
            </div>
            <div className="inline-f-b">
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.completed_submitted_toefl == 1
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => {
                      updateForm("completed_submitted_toefl", 1);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("completed_submitted_toefl", 1);
                    }}
                  >
                    Yes
                  </div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.completed_submitted_toefl == 0
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => {
                      updateForm("completed_submitted_toefl", 0);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("completed_submitted_toefl", 0);
                    }}
                  >
                    No
                  </div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.completed_submitted_toefl == 2
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => {
                      updateForm("completed_submitted_toefl", 2);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("completed_submitted_toefl", 2);
                    }}
                  >
                    Not Applicable
                  </div>
                </div>
              </div>
            </div>
            {state.completed_submitted_toeflValid === false && (
              <div className="field-error">Must select an option.</div>
            )}
          </div>
          {state.formData.completed_submitted_toefl == 1 ? (
            <div className="input-group">
              <div className="field-label">Date of TOEFL Exam</div>
              <div className="field-label">When did you take the exam?</div>
              <div className="field-label">
                If you haven't completed the exam, when do you plan to take the
                exam??
              </div>
              <div className="input-group">
                <Datepicker
                  selected={startDate}
                  onChange={(date) => iterateDate(date)}
                  showDateDropdown
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="MM/dd/yyyy"
                  minDate={setMinDate()}
                  maxDate={setMaxDate()}
                  isClearable={true}
                  // placeholder="MM/DD/YYYY"
                  placeholderText="MM/DD/YYYY"
                />

                {state.month_of_toeflValid === false && (
                  <div className="field-error">Must enter valid month.</div>
                )}
                {state.date_of_toeflValid === false && (
                  <div className="field-error">Must enter valid date.</div>
                )}
                {state.year_of_toeflValid === false && (
                  <div className="field-error">Invalid Date</div>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}

          <div className="input-group">
            <div className="field-label">
              If you do not complete the TOEFL exam and you are an international
              student and English is a second language for you, your application
              will be considered incomplete and will not be reviewed by the
              admissions committee.
              <br />
              For more information on the TOEFL Exam: https://www.ets.org/toefl
              <br />
              Contact Roberto Mendez, Financial Aid Coordinator, for VISA
              assistance as soon as possible (roberto.mendez@ctschicago.edu).
            </div>
          </div>
        </div>
        <FormAction
          isFormDataValid={state.isFormDataValid}
          formData={state.formData}
          formStep={"toeflScore"}
          backStep={"educationalHistory"}
          nextStep={"transcripts"}
        />
      </div>
    </>
  );
}

// const mapStateToProps = state => ({
//   savedSteps: state.application.savedSteps,
//   reqForm: state.user.data,
// })

export default ToeflScore;
